import { useCallback } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { useGetNonVictoriousShareContent } from './copy/nonVictorious';
import { useGetVictoriousShareContent } from './copy/victorious';

export function useGetPetitionShareContent(): ShareActionsOptions<ShareChannel>['getContent'] {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();

	const getNonVictoriousShareContent = useGetNonVictoriousShareContent();
	const getVictoriousShareContent = useGetVictoriousShareContent();

	return useCallback(
		(channel, type, { url }) =>
			status === 'VICTORY'
				? getVictoriousShareContent(channel, type, { url })
				: getNonVictoriousShareContent(channel, type, { url }),
		[status, getNonVictoriousShareContent, getVictoriousShareContent],
	);
}
